function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "User-Permissions-",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "PAGE-usermanagement-signup1",
  transform: "translate(-1310.000000, -224.000000)",
  stroke: "#4E4E4E"
}, /*#__PURE__*/React.createElement("g", {
  id: "ORGANISM-table-campaign",
  transform: "translate(64.000000, 128.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "user-greyprimary",
  transform: "translate(1247.000000, 97.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-4",
  strokeWidth: 1.06666667,
  x: 0,
  y: 0,
  width: 16,
  height: 16,
  rx: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.20008102,14.4003241 C3.91120756,11.5558179 5.51124226,10.1335648 8.00018518,10.1335648 C10.4891281,10.1335648 12.0891628,11.5558179 12.8002893,14.4003241",
  id: "Path",
  strokeWidth: 1.06668981
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  strokeWidth: 1.06668981,
  cx: 8.00018518,
  cy: 6.93349536,
  r: 3.20006944
})))));

function SvgDaxUsericon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user-greyprimary") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaxUsericon);
export default __webpack_public_path__ + "static/media/dax-usericon.f2b72b0a.svg";
export { ForwardRef as ReactComponent };